// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid[data-v-3f4b7e2b]{display:grid;gap:var(--grid-gap);height:100%}", "",{"version":3,"sources":["webpack://./resources/js/components/Grid.vue"],"names":[],"mappings":"AACA,uBACI,YAAA,CACA,mBAAA,CACA,WAAJ","sourcesContent":["\n.grid {\n    display: grid;\n    gap: var(--grid-gap);\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
